import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ArrowSingleRight"
});
const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.9004 10.3785C14.9004 10.8318 14.5352 11.1992 14.0848 11.1992H2.64414C2.34384 11.1992 2.10039 10.9543 2.10039 10.6521V9.81314L2.10405 9.74934C2.13546 9.47723 2.36529 9.26601 2.64414 9.26601L11.504 9.26638L8.96979 6.7166C8.75744 6.50294 8.75744 6.15651 8.96979 5.94284L9.45782 5.45178C9.66819 5.24009 10.0086 5.23784 10.2217 5.44672L14.6539 9.79061C14.8115 9.94509 14.9004 10.1571 14.9004 10.3785Z",
  fill: "#A5ACBE"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var arrow_single_right = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { arrow_single_right as default };
